module.exports = __webpack_public_path__ + "static/HHL-logo-8c96838998505a393dd480ca70206ffe.png";